import { LANGUAGE_SET } from '../constants/languageConstants'

export const languageReducer = (state = { language: 'hu' }, action) => {
    switch (action.type) {
        case LANGUAGE_SET:
            return {
                ...state,
                language: action.payload,
            }

        default:
            return state
    }
}
